"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useInfiniteScroll;
var _react = require("react");
function useInfiniteScroll(loadingFlag, endClause, setState) {
  var observer = (0, _react.useRef)(null);
  var lastMemberRef = (0, _react.useCallback)(function (node) {
    if (loadingFlag) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && endClause) {
        setState(function (prevPageNumber) {
          return prevPageNumber + 1;
        });
      }
    });
    if (node) observer.current.observe(node);
  }, [loadingFlag, endClause]);
  return lastMemberRef;
}